import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useEffect, useMemo, useRef, useState } from "react";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import workspaceService from "api/workspaceService";
import { IWorkspace, IWorkspaceMember } from "dto/IWorkspace";
import { useOnClickOutside } from "hooks/useClickOutside";
import { useTranslation } from "react-i18next";

const SearchMemberInWorkspace: FC<Props> = ({
  onChoose,
  clearAfterChoose,
  label,
  showMe = true,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [workspaceId] = useState(getWorkspaceId() ?? "");

  const { data: workspaceData } = workspaceService.useGetWorkspace(workspaceId);

  const workspace: IWorkspace = useMemo(
    () => (workspaceData?.data as IWorkspace) ?? [],
    [workspaceData],
  );

  const workspaceMembers = useMemo(() => workspace?.Members ?? [], [workspace]);

  const [searchedMembers, setSearchedMembers] = useState<IWorkspaceMember[]>(
    [],
  );

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (!searchValue.length) {
      setSearchedMembers(workspaceMembers.filter((x) => !x.IsMe || showMe));
      return;
    }

    // filtracja

    setSearchedMembers(
      workspaceMembers.filter(
        (m) =>
          (!m.IsMe || showMe) &&
          m.Label.toLocaleLowerCase().search(
            searchValue.toLocaleLowerCase(),
          ) !== -1,
      ),
    );
  }, [workspaceMembers, searchValue]);

  const handleClick = (member: IWorkspaceMember) => {
    setShow(false);
    if (clearAfterChoose) {
      setSearchValue("");
    } else {
      setSearchValue(member.Label);
    }
    onChoose(member);
  };

  const listRef = useRef();

  useOnClickOutside(listRef, () => {
    setShow(false);
  });

  return (
    <div className={styles.wrapper}>
      <Input
        onFocus={() => {
          setShow(true);
        }}
        label={label ?? t("common.user")}
        onChange={(t) => setSearchValue(t)}
        value={searchValue}
      />
      {show && (
        <div className={styles.list} ref={listRef}>
          <div className={styles.listWrapper}>
            {searchedMembers?.map((c) => (
              <div
                onClick={() => handleClick(c)}
                key={c.Id}
                className={styles.box}
              >
                <div className={styles.title}>{c.Label}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchMemberInWorkspace;
